import { InsightsTimeframes } from '@griply/types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SliderButtons } from 'shared/components/ui/slider-buttons';

export type InsightsTimeframeSelectionProps = {
  isFullWidth?: boolean;
  hasDarkBackground?: boolean;
  value: InsightsTimeframes;
  onChange: (timeframe: InsightsTimeframes) => void;
  preventDrag?: boolean;
  timeframes?: InsightsTimeframes[];
};

const DEFAULT_TIMEFRAMES: InsightsTimeframes[] = [
  InsightsTimeframes.Week,
  InsightsTimeframes.Month,
  InsightsTimeframes.Quarter,
  InsightsTimeframes.Year,
  InsightsTimeframes.FourWeeks,
  InsightsTimeframes.TwelveWeeks,
  InsightsTimeframes.TwelveMonths,
];

export const InsightsTimeframeSelection: React.FC<
  InsightsTimeframeSelectionProps
> = ({
  value,
  onChange,
  isFullWidth,
  hasDarkBackground,
  preventDrag,
  timeframes = DEFAULT_TIMEFRAMES,
}) => {
  const { t } = useTranslation();

  const periods = useMemo(
    () => [
      timeframes.map((timeframe) => ({
        label: t(`pages.insights.period-selection.${timeframe}`),
        value: timeframe,
        tooltip: t(`pages.insights.period-selection.${timeframe}.tooltip`),
      })),
    ],
    [t, timeframes],
  );

  return (
    <SliderButtons
      optionGroups={periods}
      value={value}
      onOption={onChange}
      isFullWidth={isFullWidth}
      hasDarkBackground={hasDarkBackground}
      preventDrag={preventDrag}
    />
  );
};
